import ErrorTemplate from "../../../components/ErrorTemplate/ErrorTemplate";
import urls from "../../../navigation/AppUrls";
import { useNavigate } from "react-router-dom";

const ForbiddenError = () => {
  const navigate = useNavigate();
  return (
    <ErrorTemplate
      islayoutUsed={true}
      header="Restricted page"
      description="You do not have permission to view this page."
      showContact
      button={{
        buttonText: "Return to home",
        onClick: () => {
          navigate(urls.HOMEPAGE);
        },
      }}
    />
  );
};

export default ForbiddenError;